import { Component, OnInit } from '@angular/core';
import { OrgService } from '../_services/org.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { StudentService } from '../_services/student.service';
import { AuthenticationService } from '../_services/authentication.service';
import { School } from '../dropdown-school/org.school';
import { PhaseService } from '../_services/phase.service';
import { Classroom } from 'src/app/dropdown-classroom/org.classroom';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
})
export class DashboardPrincipalComponent implements OnInit {
	public schools: School[];
	subscriptions: Subscription[] = [];
	classrooms: Classroom[] = [];
	selectedSchool: any;
	phases: any;
	selectedClassroom: Classroom;
	nodes: any;
	selectedNode: any;
	node: any;

	constructor(
		public OrgService: OrgService,
		private StudentService: StudentService,
		private authService: AuthenticationService,
		private orgService: OrgService,
		public phaseService: PhaseService,
		private jwtHelper: JwtHelperService
	) {}

	ngOnInit(): void {
		this.orgService.init();
		this.subscriptions.push(
			this.orgService.selectedSchool$.subscribe((data: any) => {
				this.selectedSchool = data;
			})
		);

		this.subscriptions.push(
			this.orgService.selectedClassroom$.subscribe((classroom: Classroom) => {
				this.selectedClassroom = classroom;
			})
		);
		this.subscriptions.push(
			this.orgService.schools$.subscribe((data: any) => {
				this.schools = data;
			})
		);

		this.subscriptions.push(
			this.orgService.classrooms$.subscribe((data: Classroom[]) => {
				this.classrooms = data;
				console.log('this.classrooms', this.classrooms);
			})
		);

		//decode token and get header node
		const decodedToken = this.jwtHelper.decodeToken(localStorage.getItem('currentUser'));
		console.log('decodedToken', decodedToken);
		if (decodedToken && decodedToken.attachedNode) {
			this.node = decodedToken.attachedNode;
			console.log('node', this.node);
			this.subscriptions.push(
				this.orgService.tree$(this.node.id).subscribe((data: any) => {
					this.nodes = [data];
					if (this.nodes.length > 0) {
						this.nodes[0].expanded = true;
					}
					console.log('nodes', this.nodes);
				})
			);
		}
	}

	nodeChange(node: any) {
		console.log('node', node);
		this.selectedNode = node;
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
